// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1eE3J","tab":"Tabs_tab__2NZ4Z","tabActive":"Tabs_tabActive__JEOCJ"};